module.exports = __webpack_public_path__ + "static/media/singer-min.77044a60.jpg";